import { PREFIX_COVERHOLDER } from "@/api/Model/ProductOwnerModel";
import AbstractInsuranceType from "../InsuranceType";

class InsuranceType extends AbstractInsuranceType {
  static getResourceEndpoint() {
    return PREFIX_COVERHOLDER + '/product-insurance-types-ipr';
  }
}

export default InsuranceType;
